<template>
    <div class="flex justify-center">
        <transition name="slide-swap">
            <router-view id="myrouter"></router-view>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'product-main',
    components: {},
    data() {
        return {}
    },
    computed: {},
    watch: {},
    methods: {}
}
</script>

<style scoped>
h2 {
    color: #6a6e6e;
}
</style>
